import { useEffect, useState } from "react";

declare global {
  interface Window {
    Tawk_API: any;
    Tawk_LoadStart: Date;
  }
}

const TawkToChat = () => {
  // Set this to false to temporarily disable the chat widget
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    // Only initialize if enabled
    if (!isEnabled) return;

    // Initialize Tawk.to script
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const s1 = document.createElement("script");
    const s0 = document.getElementsByTagName("script")[0];

    s1.async = true;
    s1.src = "https://embed.tawk.to/67fe273af308dc1911a9308d/1ioscifk9";
    s1.charset = "UTF-8";
    s1.setAttribute("crossorigin", "*");

    if (s0 && s0.parentNode) {
      s0.parentNode.insertBefore(s1, s0);
    }

    // Cleanup function to remove the script when component unmounts
    return () => {
      if (s1 && s1.parentNode) {
        s1.parentNode.removeChild(s1);
      }
    };
  }, [isEnabled]);

  return null; // This component doesn't render anything
};

export default TawkToChat;
